import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Box from '@nubank/nuds-web/components/Box/Box';
import { NuDsContext } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';

import { StyledLink } from './style/Link';

function SectionCrossSell({ index }) {
  const { formatMessage } = useContext(NuDsContext);
  const crossSellLinks = formatMessage({ id: `cms.accountPage.cardsArea[${index}].crossSellItem` });
  return (
    <Box
      backgroundImage={{
        xs: {
          '1x': 'hands-holding-cards/hands-holding-cards-xs@1x.jpg',
          '2x': 'hands-holding-cards/hands-holding-cards-xs@2x.jpg',
          '3x': 'hands-holding-cards/hands-holding-cards-xs@3x.jpg',
        },
        md: {
          '1x': 'hands-holding-cards/hands-holding-cards-md@1x.jpg',
          '2x': 'hands-holding-cards/hands-holding-cards-md@2x.jpg',
          '3x': 'hands-holding-cards/hands-holding-cards-md@3x.jpg',
        },
        lg: {
          '1x': 'hands-holding-cards/hands-holding-cards-lg@1x.jpg',
          '2x': 'hands-holding-cards/hands-holding-cards-lg@2x.jpg',
          '3x': 'hands-holding-cards/hands-holding-cards-lg@3x.jpg',
        },
      }}
      backgroundSize="cover"
      tag="section"
      paddingBottom={{ xs: '12x', md: '12x', lg: 56 }}
      paddingTop={{ xs: 56, md: 76, lg: '32x' }}
      paddingHorizontal={{ xs: '6x', md: '12x', lg: 56 }}
      display={{ md: 'grid' }}
      gridTemplateColumns={{ md: 'repeat(6,1fr)', lg: 'repeat(12,1fr)' }}
      gridColumnGap={{ md: '8x' }}
    >
      <Box
        marginBottom={{ xs: 152, md: 88, lg: '5x' }}
        gridColumn={{ md: '1 / span 4', lg: '2 / span 4' }}
      >
        <Typography
          color="white"
          intlKey={`cms.accountPage.cardsArea[${index}].title`}
          intlValues={{ br: (<br />) }}
          variant="title"
        />
      </Box>
      <Box
        background="white"
        paddingHorizontal={{ xs: '4x', md: 36 }}
        gridRow={{ md: '2' }}
        gridColumn={{ md: '3 /7 ', lg: '9 / 13' }}
        justifySelf={{ md: 'flex-end' }}
        paddingVertical={{ xs: '6x', md: '8x' }}
        maxWidth={{ md: 390 }}
      >
        <Typography
          variant="subtitle"
          intlKey={`cms.accountPage.cardsArea[${index}].cardTitle`}
          marginBottom={{ xs: '6x' }}
        />

        <Box tag="nav">
          {crossSellLinks.map(({ id, title, link }) => (
            <StyledLink
              key={`cross-sell-${id.toLocaleLowerCase()}`}
              href={link}
              variant="action"
              color="black"
            >
              {title}
            </StyledLink>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

SectionCrossSell.propTypes = {
  index: PropTypes.number.isRequired,
};

export default React.memo(SectionCrossSell);
